import '@babel/polyfill';
import 'bootstrap';
import 'animate.css';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import Alerta from 'Component/Alerta';
import Rota from 'Router';
import configurarStore from 'Store';

import './bootstrap';

import 'Style/app.scss';

// Configura a store pegando injetando a store gerada no servidor
const store = configurarStore(contexto);

// Hidrata o app
render(
    <React.StrictMode>
        <Provider store={ store }>
            <Alerta>
                <BrowserRouter>
                    <Rota />
                </BrowserRouter>
            </Alerta>
        </Provider>
    </React.StrictMode>,
    document.getElementById('app')
);
